import { render } from "./ProcessUserStatusLabel.vue?vue&type=template&id=51ad6848&scoped=true&ts=true"
import script from "./ProcessUserStatusLabel.vue?vue&type=script&lang=ts"
export * from "./ProcessUserStatusLabel.vue?vue&type=script&lang=ts"

import "./ProcessUserStatusLabel.vue?vue&type=style&index=0&id=51ad6848&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ad6848"]])

export default __exports__